import React from 'react';
import { Box, Typography } from '@mui/material';

interface ThinkingPartProps {
    content: string;
}

const ThinkingPart: React.FC<ThinkingPartProps> = ({ content }) => (
    <Box
        sx={{
            backgroundColor: '#f5f6fa',
            p: 2,
            borderRadius: 2,
            mb: 2,
            mt: 1,
            display: 'block',
            boxShadow: 0,
        }}
    >
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            Thinking:
        </Typography>
        <Typography
            variant="body2"
            component="div"
            sx={{
                color: 'text.secondary',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                backgroundColor: '#f5f5f5',
                borderRadius: 1,
            }}
        >
            {content}
        </Typography>
    </Box>
);

export default ThinkingPart;
